/** @format */

import React, { useState } from "react";
import profileImg from "../assets/Ephraim.jpeg";
import "./main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope as faEnvelopeSolid } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope as faEnvelopeRegular } from "@fortawesome/free-regular-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faMapMarkerAlt, faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faTwitter,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

const Sidebar = () => {
  const [isCopied, setIsCopied] = useState(false);

  const email = "ephraimimhagbe@gmail.com";
  const copyToClipboard = () => {
    navigator.clipboard.writeText(email).then(
      () => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      },
      (err) => {
        console.error("Failed to copy email: ", err);
      },
    );
  };

  return (
    <aside className="sidebar" data-sidebar>
      <div className="sidebar-info">
        <figure className="avatar-box">
          <img
            src={profileImg}
            className="rounded-xl"
            alt="Ephraim I. Emmanuel"
          />
        </figure>

        <div className="info-content">
          <h1 className="name" title="Ephraim Emmanuel">
            Ephraim I. Emmanuel
          </h1>

          <div className="flex item-center">
            <p className="title">Full Stack Developer</p>
          </div>

          <ul className="social-list py-4">
            <li className="social-item">
              <a
                href="https://www.linkedin.com/in/ephraim-imhagbe-488225194"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </li>

            <li className="social-item">
              <a
                href="https://twitter.com/ephraim_ul"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            </li>

            <li className="social-item">
              <a
                href="mailto:ephraimimhagbe@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faEnvelopeSolid} />
              </a>
            </li>

            <li className="social-item">
              <a
                href="https://github.com/Ulephraim"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </li>
          </ul>
        </div>

        <a
          href="https://drive.google.com/file/d/1HuFu96IO7b8h1KyM-nxXmAYgLQF04zol/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="cv-btn">Download CV</button>
        </a>
      </div>

      <div className="sidebar-info_more">
        <div className="separator"></div>

        <ul className="contacts-list">
          <li className="contact-item">
            <div className="icon-box">
              <FontAwesomeIcon icon={faEnvelopeRegular} />
            </div>
            <div className="contact-info">
              <p className="contact-title">Email</p>
              <div className="contact-mail">
                <a
                  href="mailto:ephraimimhagbe@gmail.com"
                  className="contact-link contact-mail-link"
                >
                  ephraimimhagbe@gmail.com
                </a>
                <button onClick={copyToClipboard} className="copy-btn ">
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              </div>

              {isCopied && (
                <div className="toast">Email address copied to clipboard!</div>
              )}
            </div>
          </li>

          <li className="contact-item">
            <div className="icon-box">
              <FontAwesomeIcon icon={faMobileAlt} />
            </div>
            <div className="contact-info">
              <p className="contact-title">Phone</p>
              <a href="tel:+2348166145418" className="contact-link">
                +234 816 614 5418
              </a>
            </div>
          </li>

          <li className="contact-item">
            <div className="icon-box">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
            </div>
            <div className="contact-info">
              <p className="contact-title">Location</p>
              <address>Lagos, Nigeria</address>
            </div>
          </li>
          <li className="contact-item">
            <a
              href="https://drive.google.com/file/d/1vWHmOWaEza9XPWLaOuG8BhadBzM_ouGK/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="cv-btn-2">Download CV</button>
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
